
export class DesignationsDto {
  designationId?: number;
  designation: string;
  status: boolean;
  createdAt : Date | any;
  createdUser : number;
  updatedAt : Date | any;
  updatedUser : number;
  versionFlag : number;
}
export const DesignationsDtoDefault : DesignationsDto = {
  designationId: 0,
  designation: "",
  status: true,
  createdAt : new Date() ,
  createdUser : 0,
  updatedAt : new Date() ,
  updatedUser : 0,
  versionFlag : 1
};